import classNames from 'classnames';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { Manager, Target, Popper } from "react-popper";
import { UserContext } from '../../context/UserContext';

// @mui/material components
import { Box, ListItemIcon, MenuItem, MenuList } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Divider from '@mui/material/Divider';
import Grow from '@mui/material/Grow';
import Hidden from '@mui/material/Hidden';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { makeStyles } from '@mui/styles';
// @mui/icons-material
import SuccessIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import Notifications from '@mui/icons-material/Notifications';
import Person from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import WarningIcon from '@mui/icons-material/WarningAmber';
import { PromptAlert } from 'features/ux/RouterPrompt';

// core components
import Button from 'components/CustomButtons/Button';

import styles from 'assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle';

import { useLogout } from '@src/api/hooks/Logout';
import {
  retrieveNotifications,
  selectNotifications,
} from 'features/notification/notificationSlice';
import { selectViewIsDirty, setViewIsDirty } from 'features/ux/uxSlice';
import { selectImpersonationMode } from '../../features/session/sessionSlice';
import {
  selectCurrentUser,
  selectNtAdministrator,
} from '../../features/user/userSlice';

const useStyles = makeStyles(styles);
let shouldLogoutDeferred = false;

export default function HeaderLinks(props) {
  const dispatch = useDispatch();
  const impersonationMode = useSelector(selectImpersonationMode);
  const user = useSelector(selectCurrentUser);
  const ntAdministrator = useSelector(selectNtAdministrator);
  const notifications = useSelector(selectNotifications);
  const viewIsDirty = useSelector(selectViewIsDirty);
  const { fetchLogout } = useLogout();

  const [showDirtySwitchAlert, setShowDirtySwitchAlert] = React.useState(false);
  const [openNotifications, setOpenNotifications] = React.useState(null);

  const getNotifications = async () => {
    await dispatch(retrieveNotifications());
  };
  const [refreshInterval, setRefreshInterval] = useState(60000);

  useEffect(() => {
    if (refreshInterval && refreshInterval > 0) {
      const interval = setInterval(getNotifications, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [refreshInterval]);

  const handleClickNotifications = (event) => {
    if (openNotifications && openNotifications.contains(event.target)) {
      setOpenNotifications(null);
    } else {
      setOpenNotifications(event.currentTarget);
    }
  };

  const logoutHandler = () => {
    if (viewIsDirty) {
      setShowDirtySwitchAlert(true);
      shouldLogoutDeferred = true;
      return;
    }

    fetchLogout();
    handleCloseProfile();
  };
  const handleCloseNotifications = () => {
    setOpenNotifications(null);
  };
  const handleReadNotification = (notification) => {
    setOpenNotifications(null);
    props.readNotificationHandler(notification);
  };
  const [openProfile, setOpenProfile] = React.useState(null);
  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };
  const handleEditProfile = () => {
    setOpenProfile(null);
    props.editProfileHandler();
  };
  const handleCloseProfile = () => {
    setOpenProfile(null);
  };
  const [openSettings, setOpenSettings] = React.useState(null);
  const handleClickSettings = (event) => {
    if (openSettings && openSettings.contains(event.target)) {
      setOpenSettings(null);
    } else {
      setOpenSettings(event.currentTarget);
    }
  };
  const handleEditSettings = () => {
    setOpenSettings(null);
    props.editSettingsHandler();
  };
  const handleCloseSettings = () => {
    setOpenSettings(null);
  };
  const handleSwitchOrganizations = () => {
    if (impersonationMode) props.exitOrganizationHandler();
    else props.switchOrganizationsHandler();
    setOpenSettings(null);
  };
  const handleSwitchEnvironment = () => {
    props.switchEnvironmentHandler();
    setOpenSettings(null);
  };
  const classes = useStyles();
  const dropdownItem = classNames(classes.dropdownItem, classes.primaryHover);
  const managerClasses = classNames({
    [classes.managerClasses]: true,
  });
  const severityIcon = (severity) => {
    var icon = null;
    switch (severity) {
      case 'error':
        icon = <ErrorIcon fontSize='small' />;
        break;
      case 'warning':
        icon = <WarningIcon fontSize='small' />;
        break;
      case 'info':
        icon = <InfoIcon fontSize='small' />;
        break;
      case 'success':
        icon = <SuccessIcon fontSize='small' />;
        break;
    }
    return icon;
  };
  const buildNotificationList = () => {
    let list = null;
    if (notifications && notifications.length > 0) {
      list = notifications.map((entry, index) => {
        const noteStyle = entry.read ? {} : { fontWeight: 700 };
        return (
          <MenuItem
            className={dropdownItem}
            key={index}
            value={entry._id}
            onClick={() => {
              handleReadNotification(entry);
            }}
          >
            <ListItemIcon style={{ topMargin: 10 }}>
              {severityIcon(entry.severity)}
            </ListItemIcon>
            <span style={noteStyle}>{entry.short_description}</span>
          </MenuItem>
        );
      });
    } else
      list = (
        <MenuItem
          key={0}
          value={0}
          onClick={handleCloseNotifications}
          className={dropdownItem}
        >
          No notifications!
        </MenuItem>
      );
    return list;
  };

  useEffect(() => {
    if (shouldLogoutDeferred) {
      shouldLogoutDeferred = false;
      logoutHandler();
    }
  }, [viewIsDirty]);

  return (
    <div>
      {showDirtySwitchAlert && (
        <PromptAlert
          onConfirm={() => {
            setShowDirtySwitchAlert(false);
            dispatch(setViewIsDirty(false));
          }}
          onCancel={() => {
            setShowDirtySwitchAlert(false);
            shouldLogoutDeferred = false;
          }}
        />
      )}
      <div className={managerClasses}>
        <Button
          color='transparent'
          justIcon
          aria-label='Notifications'
          aria-owns={openNotifications ? 'notification-menu-list' : null}
          aria-haspopup='true'
          onClick={handleClickNotifications}
          className={classes.buttonLink}
          muiClasses={{
            label: '',
          }}
        >
          <Notifications
            className={classes.headerLinksSvg + ' ' + classes.links}
          />
          {notifications && notifications.length > 0 ? (
            <span className={classes.notifications}>
              {notifications.length}
            </span>
          ) : null}
          <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <span
              onClick={handleClickNotifications}
              className={classes.linkText}
            >
              Notification
            </span>
          </Box>
        </Button>
        <Popper
          open={Boolean(openNotifications)}
          anchorEl={openNotifications}
          transition
          disablePortal
          placement='bottom'
          className={classNames({
            [classes.popperClose]: !openNotifications,
            [classes.popperResponsive]: true,
            [classes.popperNav]: true,
          })}
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              id='notification-menu-list'
              style={{ transformOrigin: '0 0 0' }}
            >
              <Paper className={classes.dropdown}>
                <ClickAwayListener onClickAway={handleCloseNotifications}>
                  <MenuList dense>{buildNotificationList()}</MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
      <div className={managerClasses}>
        <Button
          color='transparent'
          aria-label='Settings'
          justIcon
          aria-owns={openSettings ? 'settings-menu-list' : null}
          aria-haspopup='true'
          onClick={handleClickSettings}
          className={classes.buttonLink}
          muiClasses={{
            label: '',
          }}
        >
          <SettingsIcon
            className={classes.headerLinksSvg + ' ' + classes.links}
          />
          <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <span onClick={handleClickSettings} className={classes.linkText}>
              Settings
            </span>
          </Box>
        </Button>
        <Popper
          open={Boolean(openSettings)}
          anchorEl={openSettings}
          transition
          disablePortal
          placement='bottom'
          className={classNames({
            [classes.popperClose]: !openSettings,
            [classes.popperResponsive]: true,
            [classes.popperNav]: true,
          })}
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              id='settings-menu-list'
              style={{ transformOrigin: '0 0 0' }}
            >
              <Paper className={classes.dropdown}>
                <ClickAwayListener onClickAway={handleCloseSettings}>
                  <MenuList role='menu'>
                    <MenuItem
                      onClick={handleCloseSettings}
                      className={dropdownItem}
                    >
                      Settings
                    </MenuItem>
                    <Divider light />
                    {ntAdministrator ? (
                      <MenuItem
                        onClick={handleSwitchOrganizations}
                        className={dropdownItem}
                      >
                        {impersonationMode
                          ? 'Exit Organization'
                          : 'Switch Organization'}
                      </MenuItem>
                    ) : null}
                    {!ntAdministrator || impersonationMode ? (
                      <MenuItem
                        onClick={handleSwitchEnvironment}
                        className={dropdownItem}
                      >
                        Switch Environment
                      </MenuItem>
                    ) : null}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
      <div className={managerClasses}>
        <Button
          color='transparent'
          aria-label='Person'
          justIcon
          aria-owns={openProfile ? 'profile-menu-list' : null}
          aria-haspopup='true'
          onClick={handleClickProfile}
          className={classes.buttonLink}
          muiClasses={{
            label: '',
          }}
        >
          {user && user.avatar ? (
            <Avatar
              alt={user.display_name}
              src={user.avatar}
              sx={{ width: 24, height: 24 }}
            />
          ) : (
            <Person className={classes.headerLinksSvg + ' ' + classes.links} />
          )}
          <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <span onClick={handleClickProfile} className={classes.linkText}>
              Profile
            </span>
          </Box>
        </Button>
        <Popper
          open={Boolean(openProfile)}
          anchorEl={openProfile}
          transition
          disablePortal
          placement='bottom'
          className={classNames({
            [classes.popperClose]: !openProfile,
            [classes.popperResponsive]: true,
            [classes.popperNav]: true,
          })}
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              id='profile-menu-list'
              style={{ transformOrigin: '0 0 0' }}
            >
              <Paper className={classes.dropdown}>
                <ClickAwayListener onClickAway={handleCloseProfile}>
                  <MenuList role='menu'>
                    {user ? (
                      <div>
                        <span className={classes.userHeading}>
                          Logged in as:
                        </span>
                        <span className={classes.userName}>
                          {user.display_name}
                        </span>
                      </div>
                    ) : (
                      ''
                    )}
                    <Divider light />
                    <MenuItem
                      onClick={handleEditProfile}
                      className={dropdownItem}
                    >
                      Edit Profile
                    </MenuItem>
                    <MenuItem onClick={logoutHandler} className={dropdownItem}>
                      Log out
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  );
}
